import { c as _c } from "react/compiler-runtime";
import React from "react";
import style from "./FullPageError.module.scss";
import { EffektButton } from "../../components/EffektButton/EffektButton";
import { useRouter } from "next/router";
import { useAuth0 } from "@auth0/auth0-react";
import { useMainLocale } from "../../../../context/MainLocaleContext";
export const FullPageError: React.FC<{
  error?: string;
  title?: string;
}> = t0 => {
  const $ = _c(20);
  const {
    error,
    title
  } = t0;
  const {
    user,
    logout
  } = useAuth0();
  const router = useRouter();
  const mainLocale = useMainLocale();
  const defaultTitle = mainLocale === "dk" ? "Noget gik galt" : mainLocale === "sv" ? "N\xE5got gick fel" : "Noe gikk galt";
  const backButtonLabel = mainLocale === "dk" ? "Tag mig tilbage til forsiden" : mainLocale === "sv" ? "Ta mig tillbaka till startsidan" : "Ta meg tilbake til forsiden";
  const logoutLabel = mainLocale === "dk" ? "Log ud" : mainLocale === "sv" ? "Logga ut" : "Logg ut";
  const t1 = title ?? defaultTitle;
  let t2;
  if ($[0] !== t1) {
    t2 = <h1>{t1}</h1>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== error) {
    t3 = error ? <p>{error}</p> : null;
    $[2] = error;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== router) {
    t4 = () => router.push("/");
    $[4] = router;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== backButtonLabel || $[7] !== t4) {
    t5 = <EffektButton onClick={t4}>{backButtonLabel}</EffektButton>;
    $[6] = backButtonLabel;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== logout || $[10] !== logoutLabel || $[11] !== user) {
    t6 = user && <EffektButton onClick={() => logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    })}>{logoutLabel}</EffektButton>;
    $[9] = logout;
    $[10] = logoutLabel;
    $[11] = user;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <div className={style.buttons}>{t5}{t6}</div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t2 || $[17] !== t3 || $[18] !== t7) {
    t8 = <div className={style.fullpagewrapper}>{t2}{t3}{t7}</div>;
    $[16] = t2;
    $[17] = t3;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};